import React from 'react';
import { Box, ThemeProvider, Typography, useTheme } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useTranslation } from 'react-i18next';

function FilterDateInput({ selectedDate, handleDateChange }) {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Box sx={{
            width: '100%'
        }}>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-evenly',
                        alignItems: 'center'
                    }}>
                        <DateTimePicker
                            value={selectedDate.from}
                            onChange={(date) => handleDateChange(date, 'from')}
                            format="DD/MM/YYYY HH:mm"
                            ampm={false}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    border: 'none',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                },
                            }}
                        />
                        <Typography variant="body1" sx={{ mx: 1, fontWeight: 'bold' }}>
                            {t('to')}:
                        </Typography>
                        <DateTimePicker
                            value={selectedDate.to}
                            onChange={(date) => handleDateChange(date, 'to')}
                            format="DD/MM/YYYY HH:mm"
                            ampm={false}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    border: 'none',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                },
                            }}
                        />
                    </Box>
                </LocalizationProvider>
            </ThemeProvider>
        </Box>
    );
}

export default FilterDateInput;